import { DecimalPipe } from "@angular/common";
import { invoiceData } from "./invoiceData";

export class monthlypaymentRequestlist{

    public position: number;
    public dollarAmount: number;
    public alfa_agreement_number: string;
    public invoice_data: invoiceData;
    public description: string;
    public unit_price: number;
    public recurringPaymentFlag?: boolean;
}